import TeamMembersTable from './TeamMembersTable.component';

export default TeamMembersTable;
